import { PropositionButtonSchema } from '@/views/sports/components/PropositionButton/styles/PropositionButton.styles';

export const propositionButtonStyles: PropositionButtonSchema = {
  buttonBase: {
    variant: 'odds',
    opacity: '1',
  },
  buttonBaseSpanProps: {
    overflow: 'hidden',
    pos: 'relative',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    alignSelf: 'center',
    textTransform: 'capitalize',
    fontWeight: 'bold',
    fontFamily: 'body',
    fontSize: '2xs',
  },
  buttonBaseBox: {
    fontSize: 'xs',
    fontWeight: 'black',
    fontFamily: 'body',
  },
  textBase: {
    textAlign: 'center',
    color: 'beta.600',
  },
};
